import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import wrapReact from '../../../util/react';
import './index.less';
import MenuLang from './menuLang';
import MenuUser from './menu/MenuUser';
import MenuNotice from './menuNotice';
import { PATH_WEB_HOME } from '../../../config';

const svgWiserdoor = require('../../../static/image/TwinBus IP-Logo.png');

export const HeaderLayout = (props) => {
  const {
    filePath,
    className,
    handleLogout,
    user,
    auth,
    ui,
    updateUser,
    changePwd,
    changeLanguage,
    dispatch,
    handleNoticeClick,
  } = props;
  return (
    <div className={`${filePath} ${className}`}>
      <Link to={PATH_WEB_HOME}>
        <img src={svgWiserdoor} alt="logo" className="brand" />
      </Link>
      <div className="block">
        {auth.status === 'LOGIN' && (
          <MenuUser
            handleLogout={handleLogout}
            user={user}
            auth={auth}
            ui={ui.uiMenuUser}
            updateUser={updateUser}
            changePwd={changePwd}
            className="menuUser"
            dispatch={dispatch}
          />
        )}
        <MenuLang
          changeLanguage={changeLanguage}
          dispatch={dispatch}
          className="menuLang"
        />
        <MenuNotice
          handleLogout={handleLogout}
          handleNoticeClick={handleNoticeClick}
          ui={ui.uiMenuNotice}
          dispatch={dispatch}
          className="menuNotice"
        />
      </div>
    </div>
  );
};

HeaderLayout.propTypes = {
  auth: PropTypes.shape({
    status: PropTypes.string.isRequired,
  }).isRequired,
  user: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
  }).isRequired,
  changeLanguage: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired,
  handleNoticeClick: PropTypes.func.isRequired,
  updateUser: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  changePwd: PropTypes.func.isRequired,
  ui: PropTypes.shape({
    uiMenuUser: PropTypes.object.isRequired,
    uiMenuNotice: PropTypes.object.isRequired,
  }).isRequired,
  filePath: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

export default wrapReact(HeaderLayout, 'page_index_Header');
